import React, { Suspense, lazy } from 'react';

function DashboardSpinner() {
  return (
    <div className="min-h-[40vh] flex items-center justify-center bg-gray-50">
      <div className="h-12 w-12 border-4 border-signal border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export default class DashboardErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Dashboard route error:', error, info?.componentStack || '');
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-xl mx-auto p-8 text-center rtl">
          <h2 className="type-modal-title mb-2">بخش داشبورد موقتاً در دسترس نیست</h2>
          <p className="text-gray-600 text-sm mb-4">
            {this.state.error?.message || 'خطای ناشناخته'}
          </p>
          <button
            type="button"
            className="text-signal underline"
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            تلاش دوباره
          </button>
        </div>
      );
    }
    return (
      <Suspense fallback={<DashboardSpinner />}>{this.props.children}</Suspense>
    );
  }
}

export function lazyDashboard(importer, displayName = 'DashboardLazy') {
  const C = lazy(importer);
  C.displayName = displayName;
  return C;
}
